export default __webpack_public_path__ + "static/media/story-SLIDE_8.49d40d51.jpg";